<template>
  <div>
    <label>{{ label }}</label>
    <input
      :type="type"
      :placeholder="placeholder"
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
    />
  </div>
</template>
<script>
export default {
  name: "TextInput",
  props: {
    label: String,
    placeholder: String,
    type: String,
    modelValue: String,
  },
  emits: ["update:modelValue"],
  data() {
    return {
      input: "",
    };
  },
};
</script>
<style scoped>
label {
  display: block;
  font-weight: 500;
  padding-left: 15px;
  margin-top: 15px;
  font-size: 0.9em;
  color: #4d4538;
}
input {
  margin-top: 8px;
  margin-right: 15px;
  padding: 14px 16px;
  border: 2px solid transparent;
  border-radius: 10px;
  width: 100%;
  font-family: "Poppins", sans-serif;
  font-size: 0.95em;
  background-color: #fff;
  transition: border-color 0.25s ease, box-shadow 0.25s ease;
}

input:focus {
  outline: none;
  border-color: #6b5290;
  box-shadow: 0 0 0 3px rgba(107, 82, 144, 0.18);
}

::placeholder {
  font-weight: 300;
  color: #b0a898;
}
</style>
